/**
 * @generated SignedSource<<bfffb0163dd47b8b79723f3c03fea272>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ContentsClausesOperators = "IS" | "EQUAL" | "DIFFERENT" | "GREATER_THAN" | "SMALLER_THAN" | "GREATER_THAN_OR_EQUAL" | "SMALLER_THAN_OR_EQUAL";
export type ContentsContentTypeIdsClausesOperators = "DIFFERENT" | "EQUAL";
export type ContentsFiltersInput = {
  name?: ContentsFilterValueAndOperator | null;
  builderId?: ContentsFilterValueAndOperator | null;
  contentTypes?: ContentsFilterContentTypesInput | null;
  status?: ContentsFilterVariantsByStatusInput | null;
};
export type ContentsFilterValueAndOperator = {
  value: any;
  operator?: ContentsClausesOperators | null;
};
export type ContentsFilterContentTypesInput = {
  ids?: ReadonlyArray<ContentsContentTypeIdsFilterValueAndOperator> | null;
};
export type ContentsContentTypeIdsFilterValueAndOperator = {
  value: any;
  operator?: ContentsContentTypeIdsClausesOperators | null;
};
export type ContentsFilterVariantsByStatusInput = {
  draft?: boolean | null;
  published?: boolean | null;
  publishing?: boolean | null;
  unpublishing?: boolean | null;
};
export type AdvertisementsQuery$variables = {
  filters?: ContentsFiltersInput | null;
};
export type AdvertisementsQuery$data = {
  readonly contents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly variants: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly sections: ReadonlyArray<{
                readonly id: string | null;
                readonly name: string;
                readonly data: any;
              }> | null;
              readonly configurationDataSets: ReadonlyArray<{
                readonly configurations: ReadonlyArray<{
                  readonly data: any;
                }> | null;
              }> | null;
            };
          }>;
        } | null;
      };
    }>;
  };
};
export type AdvertisementsQuery = {
  variables: AdvertisementsQuery$variables;
  response: AdvertisementsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filters"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "data",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "ConfigurationData",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdvertisementsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ContentConnection",
        "kind": "LinkedField",
        "name": "contents",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentVariantConnection",
                    "kind": "LinkedField",
                    "name": "variants",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentVariantEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentVariant",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ConfigurationDataSet",
                                "kind": "LinkedField",
                                "name": "configurationDataSets",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ConfigurationData",
                                    "kind": "LinkedField",
                                    "name": "configurations",
                                    "plural": true,
                                    "selections": [
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdvertisementsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ContentConnection",
        "kind": "LinkedField",
        "name": "contents",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentVariantConnection",
                    "kind": "LinkedField",
                    "name": "variants",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentVariantEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentVariant",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ConfigurationDataSet",
                                "kind": "LinkedField",
                                "name": "configurationDataSets",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ConfigurationData",
                                    "kind": "LinkedField",
                                    "name": "configurations",
                                    "plural": true,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9bcdaf46a28c5ec755b2e7178f6964e9",
    "id": null,
    "metadata": {},
    "name": "AdvertisementsQuery",
    "operationKind": "query",
    "text": "query AdvertisementsQuery(\n  $filters: ContentsFiltersInput\n) {\n  contents(filters: $filters) {\n    edges {\n      node {\n        id\n        name\n        variants {\n          edges {\n            node {\n              id\n              sections {\n                id\n                name\n                data\n              }\n              configurationDataSets {\n                configurations {\n                  data\n                  id\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1b7cb338c65c80330a599a4b23ef9d03";

export default node;
